const keepRatio = (element: HTMLElement) => {
    let height = element.clientWidth / 16 * 9;
    element.style.height = height + 'px';
}

/**
 * needed for compute paddings for correct video container ratio - 16:9
 * @param element - container
 * @returns
 */
const getPaddingForCorrectRatio = (element: HTMLElement): string => {
    const ratio = element.clientWidth / element.clientHeight;

    if (ratio > 16 / 9) {

        const correctWidth = element.clientHeight * 16 / 9;
        const paddings = element.clientWidth - correctWidth;

        return `0 ${paddings / 2}px`;
    }
    else {
        return '0'
    }
}

export { keepRatio, getPaddingForCorrectRatio}
